module.exports = __webpack_public_path__ + "static/img/patho-polyp-item-MtPdS1NQ.428b5c03.png";